import { render, staticRenderFns } from "./labelAnnotationsDisplay.vue?vue&type=template&id=23a5ecd2&scoped=true"
import script from "./labelAnnotationsDisplay.vue?vue&type=script&lang=js"
export * from "./labelAnnotationsDisplay.vue?vue&type=script&lang=js"
import style0 from "./labelAnnotationsDisplay.vue?vue&type=style&index=0&id=23a5ecd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5ecd2",
  null
  
)

export default component.exports